import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/js/bootstrap.bundle.min'
// import 'primereact/resources/themes/nova-accent/theme.css'
import 'primereact/resources/themes/nova-light/theme.css'
import 'primereact/resources/primereact.min.css'
import 'primeicons/primeicons.css'
import './styles/main.scss'
import React, { Suspense } from 'react'
import {createRoot} from 'react-dom/client'
import CimklinikaApp from './CimklinikaApp'
import * as serviceWorker from './serviceWorker'
// import i18n (needs to be bundled ;))
import i18n from './i18n'
import {ApolloProvider, from} from '@apollo/client'
import {concat, ApolloClient, ApolloLink, HttpLink, InMemoryCache} from '@apollo/client'
import { UserContextProvider } from './components/UserContext'
import { I18nextProvider } from 'react-i18next'
import createUploadLink from 'apollo-upload-client/createUploadLink.mjs'

const uploadLink = createUploadLink({
    uri: '/graphql',
    headers: {
        'Apollo-Require-Preflight': 'true', // fontos, lásd lentebb
    },
});

const authLink = new ApolloLink((operation, forward) => {
    // add the authorization to the headers
    operation.setContext(({ headers = {} }) => ({
    headers: {
        ...headers,
        authToken: localStorage.getItem('authToken') || null,
    }
    }));

  // @ts-ignore
  return forward(operation)
})

const client = new ApolloClient({
  link: from([authLink, uploadLink]),
  cache: new InMemoryCache()
})

const container = document.getElementById('root');
const root = createRoot(container)

root.render(
    <Suspense fallback='...'>
      <I18nextProvider i18n={i18n}>
        <ApolloProvider client={client}>
          <UserContextProvider>
            <CimklinikaApp />
          </UserContextProvider>
        </ApolloProvider>
      </I18nextProvider>
    </Suspense>
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()
